import React from "react";
import { Navigate, Link, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut } from "lucide-react";

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="section max-w-[900px] mx-auto px-6 opacity-60">Loading…</div>;
  if (!user || !user.email) return <Navigate to="/admin/login" replace state={{ from: loc }} />;

  const linkStyle = (active) => ({
    color: "var(--olive)",
    opacity: active ? 1 : 0.65,
  });

  return (
    <div data-testid="admin-layout" style={{ minHeight: "60vh" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-12">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b pb-6" style={{ borderColor: "rgba(166,154,139,0.4)" }}>
          <div className="flex items-center gap-8 flex-wrap">
            <div className="font-serif-editorial wide-track" style={{ letterSpacing: "0.28em", fontSize: "1.1rem" }}>
              INSTITUTE ADMIN
            </div>
            <nav className="flex gap-6">
              <Link to="/admin" className="overline editorial-link" data-testid="admin-nav-dashboard" style={linkStyle(loc.pathname === "/admin")}>Dashboard</Link>
              <Link to="/admin/articles" className="overline editorial-link" data-testid="admin-nav-articles" style={linkStyle(loc.pathname.startsWith("/admin/articles"))}>Articles</Link>
              <Link to="/admin/resources" className="overline editorial-link" data-testid="admin-nav-resources" style={linkStyle(loc.pathname.startsWith("/admin/resources"))}>Resources</Link>
              <Link to="/admin/faqs" className="overline editorial-link" data-testid="admin-nav-faqs" style={linkStyle(loc.pathname.startsWith("/admin/faqs"))}>FAQs</Link>
            </nav>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-xs opacity-70">{user.email}</div>
            <button onClick={logout} data-testid="admin-logout" className="overline editorial-link flex items-center gap-2">
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
        <div className="py-12">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
